import React from 'react';
import './About.css';
import logo from '../assets/logo.png';

function About() {
  const coreValues = [
    {
      title: 'Unity',
      description:
        'We embrace togetherness and inclusivity, fostering strong relationships and solidarity among Marakwet members living in Australia and beyond.',
      icon: '🤝',
    },
    {
      title: 'Welfare',
      description:
        'We support one another through challenges, promoting well-being, empathy, and mutual assistance as a caring community.',
      icon: '❤️',
    },
    {
      title: 'Development',
      description:
        'We empower members through education, skills, and initiatives that contribute to personal and collective growth — both in Australia and back home.',
      icon: '🌱',
    },
  ];

  return (
    <div className="about-container">
      <div className="about-logo">
        <img src={logo} alt="MCIA Logo" />
      </div>

      <h1>About Us</h1>
      <p>
        The <strong>Marakwet Community in Australia (MCIA)</strong> is a welfare-based association that unites members
        of the Marakwet community living across Australia. The group aims to nurture a strong sense of belonging,
        ownership, and collective responsibility, fostering unity, mutual support, and shared progress among its members.
      </p>
      <p>
        MCIA provides a platform for social interaction, cultural connection, and community welfare, helping members
        support one another while celebrating their Marakwet identity. As the community grows, MCIA envisions gradually
        evolving into a development-oriented organization, engaging in initiatives that promote education, empowerment,
        and sustainable progress both in Australia and back home.
      </p>
      <p>
        <strong>MCIA stands for unity, welfare, and development — a community moving forward together.</strong>
      </p>

      {/* Core Values Section */}
      <section className="core-values">
        <h2>Our Core Values</h2>
        <div className="values-grid">
          {coreValues.map((value, index) => (
            <div key={index} className="value-card">
              <div className="value-icon">{value.icon}</div>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default About;
